import React, { Component } from 'react';
import { Panel, Button } from 'react-bootstrap';
import {
  RENT_MIN,
  RENT_MAX,
  RENT_STEP,
  RENT_DEFAULT,
  ROOMS_MIN,
  ROOMS_MAX,
  ROOMS_STEP,
  ROOMS_DEFAULT,
  SIZE_MIN,
  SIZE_MAX,
  SIZE_STEP,
  SIZE_DEFAULT
} from '../../common/defaults';
import RangeSlider from '../../common/range-slider';
import i18n from 'kodyl-js/i18n/react';

const defaultValues = {
  rent: RENT_DEFAULT,
  size: SIZE_DEFAULT,
  rooms: ROOMS_DEFAULT
};

function checkValues(obj) {
  const values = ['rent', 'rooms', 'size'];

  return values.reduce((acc, value) => {
    if (obj[value] === defaultValues[value]) {
      return acc;
    }
    acc[value] = obj[value];
    return acc;
  }, {});
}

@i18n
class Panels extends Component {
  constructor(props) {
    super(props);
    const { prefs } = props;
    this.state = {
      rent: prefs.rent || RENT_DEFAULT,
      rooms: prefs.rooms || ROOMS_DEFAULT,
      size: prefs.size || SIZE_DEFAULT
    };
  }

  componentWillReceiveProps(nextProps) {
    const { prefs } = nextProps;
    if (prefs) {
      this.setState({
        rent: prefs.rent || RENT_DEFAULT,
        rooms: prefs.rooms || ROOMS_DEFAULT,
        size: prefs.size || SIZE_DEFAULT
      });
    }
  }

  getValue = (range, type) => {
    this.setState({ [type]: range });
  };

  getSlider(name) {
    switch (name) {
      case 'rent':
        return {
          anchorLeft: true,
          min: RENT_MIN,
          max: RENT_MAX,
          step: RENT_STEP,
          parentState: 'rent',
          value: this.state.rent,
          measurement: this.i18n('DKK'),
          label: this.i18n('Maximum rent per month'),
          headline: this.i18n('Rent')
        };
      case 'rooms':
        return {
          anchorLeft: false,
          min: ROOMS_MIN,
          max: ROOMS_MAX,
          step: ROOMS_STEP,
          parentState: 'rooms',
          value: this.state.rooms,
          measurement: this.i18n('rooms'),
          label: this.i18n('Minimum number of rooms'),
          headline: this.i18n('Rooms')
        };
      case 'size':
        return {
          anchorLeft: false,
          min: SIZE_MIN,
          max: SIZE_MAX,
          step: SIZE_STEP,
          parentState: 'size',
          value: this.state.size,
          measurement: this.i18n('m2'),
          label: this.i18n('Minimum size'),
          headline: this.i18n('Size')
        };
      default:
        return {};
    }
  }

  render() {
    const { area, update, open } = this.props;
    const { rent, rooms, size } = this.state;
    return (
      <div
        className={`boligagent-panel ${open ? 'add-spacing' : 'hide-border'}`}
      >
        <Panel expanded={open} onToggle={() => null} bsStyle="primary">
          <Panel.Collapse>
            <Panel.Body>
              {open &&
                ['rent', 'rooms', 'size'].map(item => {
                  const { headline, ...sliderProps } = this.getSlider(item);
                  return (
                    <div key={item}>
                      <label
                        htmlFor={`housing-${item}`}
                        className="col-sm-3 control-label noui-slider"
                      >
                        {headline}
                      </label>
                      <div className="col-sm-9">
                        <RangeSlider onSlide={this.getValue} {...sliderProps} />
                      </div>
                    </div>
                  );
                })}
              <Button
                bsStyle="success"
                style={{ marginTop: 15 }}
                onClick={() => update(area, checkValues({ rent, rooms, size }))}
                bsSize="small"
              >
                {this.i18n('Save changes')}
              </Button>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}

export default Panels;
